import React, { type AnchorHTMLAttributes } from 'react';

const isValidHttpUrl = (maybeUrl: string) => {
  try {
    const url = new URL(maybeUrl);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch (_) {
    return false;
  }
};

export const ClickableUrl = ({
  href,
  children,
  ...rest
}: AnchorHTMLAttributes<HTMLAnchorElement> & {
  href: string;
}) =>
  isValidHttpUrl(href) ? (
    <a href={href} {...rest}>
      {children || href}
    </a>
  ) : (
    <>{href}</>
  );
